import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sensors-view" }
const _hoisted_2 = { class: "font-weight-medium" }

import { ref, onMounted, computed } from 'vue'
import { useSensorStore } from './store'
import { Sensor } from './models/sensor'


export default /*@__PURE__*/_defineComponent({
  __name: 'SensorsView',
  setup(__props) {

const sensorStore = useSensorStore()
const loading = ref(false)

const headers = [
  { title: 'ID', key: 'id' },
  { title: 'Campo', key: 'field' },
  { title: 'Nombre', key: 'name' },
  { title: 'Unidad', key: 'unit' },
  { title: 'Color', key: 'color' },
  { title: 'Tipo', key: 'type' },
  { title: 'Creado', key: 'createdAt' },
  { title: 'Creado por', key: 'createdBy' },
  { title: 'Acciones', key: 'actions', sortable: false },
]

const sensorsList = computed(() => sensorStore.sensors)

const formatDate = (date: Date | string) => {
  return new Date(date).toLocaleDateString('es-ES')
}

const getContrastColor = (hexColor: string) => {
  // Función para determinar si usar texto blanco o negro según el color de fondo
  if (!hexColor || hexColor === '') return '#000000'
  
  // Remover el # si existe
  const color = hexColor.replace('#', '')
  
  // Convertir a RGB
  const r = parseInt(color.substring(0, 2), 16)
  const g = parseInt(color.substring(2, 4), 16)
  const b = parseInt(color.substring(4, 6), 16)
  
  // Calcular luminancia
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  
  return luminance > 0.5 ? '#000000' : '#ffffff'
}

const refreshData = async () => {
  loading.value = true
  try {
    await sensorStore.getSensors()
  } finally {
    loading.value = false
  }
}

const addItem = () => {
  // Implementar lógica para agregar sensor
  console.log('Add new sensor')
}

const editItem = (item: Sensor) => {
  // Implementar lógica de edición
  console.log('Edit item:', item)
}

const deleteItem = (item: Sensor) => {
  // Implementar lógica de eliminación
  console.log('Delete item:', item)
}

onMounted(() => {
  refreshData()
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("h1", null, "Sensors", -1),
                _createElementVNode("p", null, "Gestión de sensores del sistema", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  headers: headers,
                  items: sensorsList.value,
                  loading: loading.value,
                  class: "elevation-1"
                }, {
                  top: _withCtx(() => [
                    _createVNode(_component_v_toolbar, { flat: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_toolbar_title, null, {
                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createTextVNode("Lista de Sensores")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_divider, {
                          class: "mx-4",
                          inset: "",
                          vertical: ""
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          onClick: refreshData
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode("mdi-refresh")
                              ])),
                              _: 1
                            }),
                            _cache[3] || (_cache[3] = _createTextVNode(" Actualizar "))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          color: "success",
                          class: "ml-2",
                          onClick: addItem
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => _cache[4] || (_cache[4] = [
                                _createTextVNode("mdi-plus")
                              ])),
                              _: 1
                            }),
                            _cache[5] || (_cache[5] = _createTextVNode(" Agregar Sensor "))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  "item.color": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      style: _normalizeStyle({ backgroundColor: item.color, color: getContrastColor(item.color) }),
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.color), 1)
                      ]),
                      _: 2
                    }, 1032, ["style"])
                  ]),
                  "item.field": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "blue",
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.field), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.type": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "purple",
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.type), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.unit": _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(item.unit), 1)
                  ]),
                  "item.createdAt": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(formatDate(item.createdAt)), 1)
                  ]),
                  "item.actions": _withCtx(({ item }) => [
                    _createVNode(_component_v_icon, {
                      small: "",
                      class: "mr-2",
                      onClick: ($event: any) => (editItem(item))
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode(" mdi-pencil ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_v_icon, {
                      small: "",
                      onClick: ($event: any) => (deleteItem(item))
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode(" mdi-delete ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["items", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})